import { BUCKET_READBOOKS_URL } from "./vars";

export function getBookImage(path?: string, increaseQuality?: boolean): string {
    if(!path) return '/img/book_transparent.png';
    path = path.replace('../', "");
    path = path.replace('public/', "");
    path = path.replace('img_livros/', "img_books/");

    path = path.replace('http://books.google.com', "https://books.google.com");

    // img contem http (api)
    if (path.includes('books.google.com') && increaseQuality)
        return path.replace('zoom=5', 'zoom=6');
    
    // não tem https
    if (!path.includes('http://') && !path.includes('https://'))
        return `${BUCKET_READBOOKS_URL}/${path}`;

    return path;
}